import { P, Segments } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { Path } from "paper";
export class Tick {
    constructor() {
        this.drivers = [
            // Length.
            {
                type: "rectangle",
                minX: 40, maxX: 250,
                minY: 40, maxY: 250,
                toAppearance: (f, p) => f({
                    length: (p.x + p.y) / 2 * Math.SQRT2,
                }),
                fromAppearance: a => {
                    const x = a.length / Math.SQRT2;
                    return P(x, -x);
                },
                scale: 1.0,
            },
            {
                type: "rectangle",
                minX: 0, maxX: 0,
                minY: 5, maxY: 50,
                toAppearance: (f, p) => f({
                    thickness: p.y / Math.SQRT2 * 2,
                }),
                fromAppearance: a => P(0, a.thickness / 2 * Math.SQRT2),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        const { thickness, length } = appearance;
        const semiLength = length * 0.5;
        const halfThick = thickness * 0.5;
        const graphic = new Path(Segments([[-halfThick, -halfThick]], [[-halfThick, -length]], [[halfThick, -length]], [[halfThick, halfThick]], [[-semiLength, halfThick]], [[-semiLength, -halfThick]]));
        graphic.closePath();
        graphic.rotate(45, P(0, 0));
        const shape = graphic.clone();
        BasicShapes.applyStyle(graphic, appearance);
        return {
            graphic: graphic,
            hitShape: shape,
        };
    }
}
Tick.properties = {
    label: "Tick",
    defaultAppearance: Object.assign({ thickness: 40, length: 120 }, BasicShapes.defaultAppearance),
    appearanceSpecs: [
        ...BasicShapes.specs
    ],
};
